/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import clsx from "clsx";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import {
  Avatar,
  Box,
  Timestamp,
  Typography,
  TimestampProps,
  useScrollIntoView,
} from "@talentpair/quantic";
import RenderText from "kyoto/components/RenderText";

export type MessageListItemProps = {
  title: React.ReactNode;
  content: React.ReactNode;

  // We assume ringed avatar here wrt to spacing
  // so if non-ringed avatar supplied then caller must set the correct 8px margin/padding (level 2 spacing)
  avatar: React.ReactNode;
  children?: React.ReactNode;

  last?: boolean;

  // timestamp props
  date?: TimestampProps["date"];
  timestamp?: TimestampProps["variant"];

  "data-testid"?: string;
  className?: string;
};

export function MessageListItem({
  title,
  content,
  avatar,
  children,
  date,
  timestamp,
  className,
  last,
  ...props
}: MessageListItemProps): React.ReactElement {
  const ref = useScrollIntoView(last);
  return (
    <Box
      boxRef={ref}
      component="li"
      variant="column"
      layout="stretch-start"
      className={clsx("full-width py2 pr2", className)}
      {...props}
    >
      <Box variant="row" layout="start-start" space={1} className="full-width">
        <Box flex="auto" className="overflow-hidden">
          <Box variant="row" layout="start-start" space={1} {...props}>
            {avatar ? (
              <div style={{ marginTop: -4 }}>{avatar}</div>
            ) : (
              <Avatar
                variant="circular"
                fill="icon"
                Icon={PermIdentityOutlinedIcon}
                size="md"
                color="grey.600"
                background="grey.200"
                style={{ margin: "0 12px 0 8px" }}
              />
            )}
            <Box variant="column">
              <Typography paragraph bold>
                {title}
              </Typography>
              {typeof content === "string" ? (
                <Typography variant="body2" paragraph>
                  <RenderText text={content} />
                </Typography>
              ) : (
                <Typography variant="body2" paragraph className="pre-wrap">
                  {content}
                </Typography>
              )}
            </Box>
          </Box>
        </Box>
        <Box variant="column" layout="end-start" flex="none">
          {date ? <Timestamp variant={timestamp || "default"} date={date} /> : null}
        </Box>
      </Box>
      {children}
    </Box>
  );
}
